export function displayMod(mod) {
    mod = parseInt(mod);
    if (mod === 0) return ''
    if (mod < 0) return ' '+mod;
    return ' +' + mod;
}